(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4901],{

/***/ 2264:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suppliers",
      function () {
        return __webpack_require__(7362);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6886);
/* harmony import */ var _styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const SILink = (param)=>{
    let { children , onClick =(e)=>{} , ...props } = param;
    const handleOnClick = (e)=>{
        // @ts-ignore
        onClick(e);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: "".concat((_styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().link), " ").concat(props.classes ? props.classes : ""),
        ...props,
        onClick: handleOnClick,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SILink);


/***/ }),

/***/ 7362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_pages_supplier_index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(706);
/* harmony import */ var _styles_pages_supplier_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_supplier_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_link_silink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5515);






// @ts-ignore
function Suppliers(param) {
    let { pdfDetails  } = param;
    /***
     * This page includes the header and footer components
     * The data contain the location of company about company and registration form
     */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_styles_pages_supplier_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().banner),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/assets/images/banners/supplier/supplier_banner_d.webp",
                        alt: "about us banner",
                        loading: "lazy",
                        fill: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "details_container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "sidr_text",
                                children: "your portal for"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "title_text",
                                children: "becoming a supplier"
                            }),
                            pdfDetails.Supplier_Code_of_Conduct && pdfDetails.Supplier_Code_of_Conduct.data && pdfDetails.Supplier_Code_of_Conduct.data.attributes && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                className: "header_button",
                                href: pdfDetails.Supplier_Code_of_Conduct.data.attributes.url,
                                target: "_blank",
                                download: "SIDR Supplier Code of Conduct",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "new supplier"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: (_styles_pages_supplier_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().section_map),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "group",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/assets/images/decorations/supplier/supplier_usa_map.webp",
                            alt: "california's location on usa map"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "title_text",
                            children: [
                                "we are situated in",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "california"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "description",
                            children: "Because of its large population and consistent, easy to transport opportunities, California is an ideal destination for companies to conduct business. The California economy is growing every day, which means growing in every area so we can focus on producing  'the finest products for more people.'"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: (_styles_pages_supplier_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().section_card),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "group",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/assets/images/decorations/extra/sidr_logo_golden.svg",
                            alt: "sidr logo"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                            className: "title_text",
                            children: [
                                "bulk honey suppliers",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    children: "natural crafts"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "description",
                            children: [
                                "SIDR is looking to team up with the world’s leading bulk honey suppliers across honey industry. We trade all fresh seasonal top quality harvests, including all kinds of honey. If you feel like you share our progressive goals and quality.",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "Download the document below, fill it out and send it to us via e-mail.",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "We’ll reach out to you once this has been processed. If you’re having difficulty completing the application, please let us know and we’ll schedule a call.",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "For any questions, please contact us at ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "mailto:care@sidr.com",
                                    children: "care@sidr.com"
                                })
                            ]
                        }),
                        pdfDetails && pdfDetails.Supplier_Code_of_Conduct && pdfDetails.Supplier_Code_of_Conduct.data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "white_logo",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/assets/images/decorations/supplier/supplier_registration_logo.svg",
                                        alt: "sidr logo"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "caption1",
                                    children: pdfDetails.Supplier_Code_of_Conduct.data.attributes.caption
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "caption2",
                                    children: "Registration Form Document"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    className: "download_button",
                                    href: pdfDetails.Supplier_Code_of_Conduct.data.attributes.url,
                                    target: "_blank",
                                    download: "SIDR Supplier Code of Conduct",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "download"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_styles_pages_supplier_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().bulk_honey),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "desktop",
                        src: "/assets/images/decorations/supplier/supplier_buy_in_bulk_banner.webp",
                        alt: "bulk honey"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "ipad",
                        src: "/assets/images/decorations/supplier/supplier_buy_in_bulk_banner_ipad.webp",
                        alt: "bulk honey"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "mobile",
                        src: "/assets/images/decorations/supplier/supplier_buy_in_bulk_banner_mobile.webp",
                        alt: "bulk honey"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "content",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    children: "wholesale"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    children: "bulk honey"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "Elevate your restaurant, hotel, patisserie, or cafe with our premium selection of 100% pure honey. Our gourmet market honey, including unfiltered and raw varieties, can be yours at discounted wholesale prices. ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "Craft delicious recipes using our hand-harvested honey, setting your establishment apart in the market. Don't miss this opportunity to sweeten your offerings and impress your customers."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_link_silink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        classes: "",
                                        href: "/buy-in-bulk",
                                        children: "Buy Now"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Suppliers);


/***/ }),

/***/ 6886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","link":"link_link__T8hPh","about-image-in":"link_about-image-in__JsJpN","fade-in-honeycomb":"link_fade-in-honeycomb__iJ7y6","dot-falling":"link_dot-falling__xjMoT","dot-falling-before":"link_dot-falling-before__Qz2nK","dot-falling-after":"link_dot-falling-after__fHF3N"};

/***/ }),

/***/ 706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","banner":"supplier_banner__KtwtP","section_map":"supplier_section_map__w8Txu","section_card":"supplier_section_card__tHiMR","bulk_honey":"supplier_bulk_honey__tYz2p","about-image-in":"supplier_about-image-in__ypkk3","fade-in-honeycomb":"supplier_fade-in-honeycomb__I2lP7","dot-falling":"supplier_dot-falling__yLjcg","dot-falling-before":"supplier_dot-falling-before__SBTVs","dot-falling-after":"supplier_dot-falling-after__KiX8v"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(2264); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);